import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import SiteComponent from '../SiteComponent/SiteComponent';
import KnowledgeAssistanceLazy from './KnowledgeAssistanceLazy';
import * as styles from './KnowledgeAssistance.css';
import config from './KnowledgeAssistance.config';
import { SIZE_GUIDE } from '../../common/Constants';
import AnalyticsAction from '../../actions/AnalyticsAction';
import { selectFeatureFlags } from '../../selectors/ContextSelector';

const cx = classNames.bind(styles);

class KnowledgeAssistance extends SiteComponent {
    constructor(props) {
        super(props);
        this.state = {
            modelOpen: false,
            modelOpenOnce: false,
            knowledgeAssistants: [],
            selectedka: '',
        };
        this.triggerOpenModel = this.triggerOpenModel.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.getKnowledgeAssistant = this.getKnowledgeAssistant.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    static propTypes = {
        dataAutomationId: PropTypes.string,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        placement: PropTypes.oneOf([
            config.placement.TOP_PLACEMENT,
            config.placement.BOTTOM_PLACEMENT,
        ]),
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        miniPDPSTL: PropTypes.string,
    };

    static defaultProps = {
        dataAutomationId: '',
        productDetails: {},
        placement: '',
        actions: {},
        featureFlags: {},
        miniPDPSTL: '',
    };

    triggerOpenModel = (ka = {}, isSizeGuide = false) => {
        this.setState({
            modelOpen: true,
            selectedka: ka.id,
        });
        this.setState((prevState) => ({
            modelOpenOnce: prevState.modelOpenOnce ? prevState.modelOpenOnce : true,
        }));
        this.handleAnalytics(ka, isSizeGuide);
    };

    handleAnalytics = (ka = {}, isSizeGuide = false) => {
        if (this.props.actions.pdpKaClickAnalytics) {
            const payload = {
                Event_PDP_Tool_Name: `${isSizeGuide ? 'Size Guide' : ka.kaType}:${ka.name}`,
            };
            this.props.actions.pdpKaClickAnalytics(payload);
        }
    };

    closeModal = () => {
        this.setState({
            modelOpen: false,
        });
    };

    isSizeGuide = (ka) => {
        return SIZE_GUIDE.SIZE_GUIDE_SECTIONS in ka;
    };

    renderKAButton = () => {
        const { knowledgeAssistants, modelOpen, selectedka } = this.state;
        const {
            dataAutomationId,
            featureFlags,
            placement,
            productDetails,
            templateType,
            miniPDPSTL,
        } = this.props;
        let renderKA = null;
        /* istanbul ignore next */
        const initialKa = knowledgeAssistants || [];
        let KAData = [...initialKa];
        /* istanbul ignore next */
        if (
            placement === config.placement.BOTTOM_PLACEMENT &&
            templateType &&
            templateType.toLowerCase() === 'bundle' &&
            !featureFlags.disableDataSizeChart
        ) {
            const ka = get(productDetails, 'kaWithSizeGuide.knowledgeAssistants', {});
            const sg = get(productDetails, 'kaWithSizeGuide.sizeGuide', {});
            KAData = [...ka, ...sg];
        } else {
            const sizeGuides = [get(productDetails, 'sizeGuide', {})];
            if (
                sizeGuides.length > 0 &&
                !isEmpty(Object.keys(sizeGuides[0])) &&
                !featureFlags.disableDataSizeChart
            ) {
                KAData = filter(initialKa, (o) => {
                    return o.kaType !== SIZE_GUIDE.SIZE_CHART;
                });
                sizeGuides.forEach((sizeGuide) => {
                    KAData.push(sizeGuide);
                });
            }
        }
        return KAData.map((knowledgeAssistant, index) => {
            let style = '';
            let keyIndex = '';
            /* istanbul ignore next */
            if (knowledgeAssistant) {
                style =
                    placement === config.placement.TOP_PLACEMENT
                        ? 'topPlacementStyle'
                        : 'bottomPlacementStyle';
                const { type } = knowledgeAssistant;
                const katype = knowledgeAssistant.kaType;
                const isSizeGuideForKA = this.isSizeGuide(knowledgeAssistant);
                keyIndex = index + 1;
                let KALink = '';
                if (placement === config.placement.TOP_PLACEMENT) {
                    if (katype && config.KAMap[katype]) {
                        KALink = config.KAMap[katype];
                    } else if (isSizeGuideForKA && !featureFlags.disableDataSizeChart) {
                        KALink = SIZE_GUIDE.SIZE_CHART;
                    }
                }

                if (placement === config.placement.BOTTOM_PLACEMENT) {
                    KALink = knowledgeAssistant.name;
                }

                /* ------ content type : pdf ------- */
                if (type === 'pdf') {
                    if (placement === config.placement.BOTTOM_PLACEMENT && templateType) {
                        renderKA = (
                            <Button
                                aria-label={knowledgeAssistant.name}
                                className={dt([
                                    'sm:!text-base',
                                    'lg:max-w-[300px]',
                                    'w-full',
                                    'text-center',
                                    'py-[7px]',
                                ])}
                                id="kaLinkPdf"
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                linkUrl={knowledgeAssistant.url}
                                onClick={() => this.handleAnalytics(knowledgeAssistant)}
                                target="_new"
                                buttonType="Secondary"
                            >
                                {KALink}
                            </Button>
                        );
                    } else {
                        renderKA = (
                            <a
                                aria-label={knowledgeAssistant.name}
                                className={cx('kaLinkPdf')}
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                href={knowledgeAssistant.url}
                                onClick={() => this.handleAnalytics(knowledgeAssistant)}
                                target="_new"
                            >
                                {' '}
                                {KALink}{' '}
                            </a>
                        );
                    }
                }
                /* ------ content type : html ------- */
                if (type === 'html') {
                    if (placement === config.placement.BOTTOM_PLACEMENT && templateType) {
                        renderKA = (
                            <Button
                                aria-label={knowledgeAssistant.name}
                                className={dt([
                                    'sm:!text-base',
                                    'lg:max-w-[300px]',
                                    'w-full',
                                    'text-center',
                                    'py-[7px]',
                                ])}
                                id="kaLinkHtml"
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.triggerOpenModel(knowledgeAssistant);
                                }}
                                type="button"
                                buttonType="Secondary"
                            >
                                {KALink}
                            </Button>
                        );
                    } else {
                        renderKA = (
                            <button
                                aria-label={knowledgeAssistant.name}
                                className={cx('kaLinkHtml')}
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.triggerOpenModel(knowledgeAssistant);
                                }}
                                type="button"
                            >
                                {KALink}
                            </button>
                        );
                    }
                }
                /* ------ content type : image ------- */
                if (type === 'image') {
                    if (placement === config.placement.BOTTOM_PLACEMENT && templateType) {
                        renderKA = (
                            <Button
                                aria-label={knowledgeAssistant.name}
                                className={dt([
                                    'sm:!text-base',
                                    'lg:max-w-[300px]',
                                    'w-full',
                                    'text-center',
                                    'py-[7px]',
                                ])}
                                id="kaLinkImage"
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.triggerOpenModel(knowledgeAssistant);
                                }}
                                type="button"
                                buttonType="Secondary"
                            >
                                {KALink}
                            </Button>
                        );
                    } else {
                        renderKA = (
                            <button
                                aria-label={knowledgeAssistant.name}
                                className={cx('kaLinkImage')}
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.triggerOpenModel(knowledgeAssistant);
                                }}
                                type="button"
                            >
                                {KALink}
                            </button>
                        );
                    }
                }
                /* ------ KA type : Size Chart ------- */
                if (isSizeGuideForKA && !featureFlags.disableDataSizeChart) {
                    if (placement === config.placement.BOTTOM_PLACEMENT && templateType) {
                        renderKA = (
                            <Button
                                aria-label={knowledgeAssistant.name}
                                className={dt([
                                    'sm:!text-base',
                                    'lg:max-w-[300px]',
                                    'w-full',
                                    'text-center',
                                    'py-[7px]',
                                ])}
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.triggerOpenModel(knowledgeAssistant, true);
                                }}
                                type="button"
                                buttonType="Secondary"
                            >
                                {KALink}
                            </Button>
                        );
                    } else {
                        renderKA = (
                            <button
                                aria-label={knowledgeAssistant.name}
                                className={cx('kaLinkSizeGuide')}
                                data-automation-id={`${dataAutomationId}-link-${knowledgeAssistant.name}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.triggerOpenModel(knowledgeAssistant, true);
                                }}
                                type="button"
                            >
                                {KALink}
                            </button>
                        );
                    }
                }
                const bottonContainerStyle =
                    placement === config.placement.BOTTOM_PLACEMENT ? ['mt-4', 'first:mt-3'] : [''];
                return (
                    <div
                        className={[cx(style), dt([...bottonContainerStyle])].join(' ')}
                        key={keyIndex}
                    >
                        {renderKA}
                        {modelOpen && selectedka === knowledgeAssistant.id ? (
                            <KnowledgeAssistanceLazy
                                knowledgeAssistant={knowledgeAssistant}
                                openModel={this.triggerOpenModel}
                                closeModal={this.closeModal}
                                dataAutomationId={this.props.dataAutomationId}
                                isSizeGuideForKA={isSizeGuideForKA}
                                isOpenPanel={this.state.modelOpen}
                                isOpenPanelOnce={this.state.modelOpenOnce}
                                miniPDPSTL={miniPDPSTL}
                            />
                        ) : null}
                    </div>
                );
            }
            return null;
        });
    };

    componentDidMount() {
        this.setKnowledgeAssistant();
    }

    getKnowledgeAssistant(placement) {
        const { featureFlags, productDetails, templateType } = this.props;
        const knowledgeAssistants = productDetails.knowledgeAssistants
            ? this.props.productDetails.knowledgeAssistants
            : [];
        let sizeGuides = [];
        if (
            templateType &&
            templateType.toLowerCase() === 'bundle' &&
            placement === config.placement.BOTTOM_PLACEMENT
        ) {
            sizeGuides = get(productDetails, 'sizeGuide', []);
        } else {
            sizeGuides = [get(productDetails, 'sizeGuide', {})];
        }
        const isSizeGuideAvailable =
            sizeGuides.length > 0 &&
            !isEmpty(Object.keys(sizeGuides[0])) &&
            !featureFlags.disableDataSizeChart;
        const KAContentForSkuSec = [];
        const KAContentForProdDecSec = [];
        let knowledgeAssistantsContent = [];
        if (knowledgeAssistants.length > 0) {
            knowledgeAssistants.forEach((knowledgeAssistant) => {
                if (
                    KAContentForSkuSec.length === 0 &&
                    knowledgeAssistant &&
                    knowledgeAssistant.kaType !== 'Glossary' &&
                    knowledgeAssistant.kaType !== 'Tips' &&
                    knowledgeAssistant.kaType !== 'Delivery Checklist' &&
                    knowledgeAssistant.kaType !== 'PP Based' &&
                    !isSizeGuideAvailable
                ) {
                    KAContentForSkuSec.push(knowledgeAssistant);
                    KAContentForProdDecSec.push(knowledgeAssistant);
                } else {
                    KAContentForProdDecSec.push(knowledgeAssistant);
                }
            });
            if (placement === config.placement.TOP_PLACEMENT) {
                knowledgeAssistantsContent = KAContentForSkuSec;
            }
            if (placement === config.placement.BOTTOM_PLACEMENT) {
                knowledgeAssistantsContent = KAContentForProdDecSec;
            }
        }
        return knowledgeAssistantsContent;
    }

    setKnowledgeAssistant = () => {
        this.setState({
            knowledgeAssistants: this.getKnowledgeAssistant(this.props.placement),
        });
    };

    render() {
        return (
            <div data-automation-id={`${this.props.dataAutomationId}-knowledgeAssistants`}>
                {this.renderKAButton()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    featureFlags: selectFeatureFlags(state),
    deviceType: state.context ? state.context.deviceType : {},
    miniPDPSTL: state.miniPDP ? state.miniPDP.miniPDPSTL : '',
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(AnalyticsAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeAssistance);
